import React from "react";
import faruk from "../../assets/ffff.png"
import { MdLabelImportant } from "react-icons/md";
import about1 from "../../assets/about1.jpg";
import about2 from "../../assets/event2.2.jpg";
const OurCeo = () => {
  return (
    <div className="flex flex-col gap-4">
      
      <div className="flex lg:flex-row flex-col gap-[3rem]">
        <img src={faruk} alt="Faruk" className="w-[20rem] rounded-xl shadow-[0_0_14px_8px_#22beff]"/>
        <div className="flex flex-col gap-4">
            
            <h3 className="text-2xl font-bold text-[#bfbfbf]">ফারুক হোসেন</h3>
            <span className="text-xl font-bold text-[#bfbfbf]">একজন শিক্ষাবিদ, OBE প্রশিক্ষক ও  লাইফ কোচ</span>
            <p className="text-[#bfbfbf] text-xl text-justify">বাংলাদেশের উচ্চশিক্ষা এবং ব্যক্তিগত উন্নয়নের জগতে ফারুক হোসেন একটি পরিচিত নাম। তিনি বহুমাত্রিক প্রতিভার অধিকারী—একজন শিক্ষাবিদ (Academician), আউটকাম বেইজড এডুকেশন (Outcome Based Education বা OBE) প্রশিক্ষক, এবং একজন জীবন পরামর্শদাতা (Life Coach) ।</p>
            <span className="text-xl font-bold text-[#bfbfbf] flex items-center gap-1"><MdLabelImportant className="text-[#22BEFF]"/>শিক্ষাবিদ হিসেবে ভূমিকা</span>
            <p className="text-[#bfbfbf] text-xl text-justify">শিক্ষাক্ষেত্রে ফারুক হোসেনের অবদান প্রশংসনীয়। তিনি বাংলাদেশের একাধিক বিশ্ববিদ্যালয়ে শিক্ষকতা করেছেন, যেখানে তিনি কেবল পাঠদানই করেননি, বরং শিক্ষার গুণগত মানোন্নয়নের জন্য নিরলস কাজ করে গেছেন। তাঁর মতে, “শিক্ষা হলো এমন একটি প্রক্রিয়া যা একজন মানুষকে শুধুমাত্র ডিগ্রিধারী নয়, বরং সমস্যার সমাধানকারী, নেতৃত্বদানে সক্ষম, ও মূল্যবোধসম্পন্ন একজন ব্যক্তি হিসেবে গড়ে তোলে।”তিনি পাঠদানে যুক্ত করেন সমকালীন পদ্ধতি, তথ্যপ্রযুক্তি, এবং বাস্তব জীবনের উদাহরণ। তিনি প্রায়ই বলেন, “বইয়ের জ্ঞান যদি জীবনে কাজে না লাগে, তবে সে জ্ঞান অর্ধেক।”</p>


        </div>

      </div>
        <span className="text-xl font-bold text-[#bfbfbf] sm:mt-[4rem] flex items-center gap-1"><MdLabelImportant className="text-[#22BEFF]"/>Outcome Based Education (OBE) প্রশিক্ষক হিসেবে কাজ</span>
        <p className="text-[#bfbfbf] text-xl text-justify">ফারুক হোসেন OBE-এর একজন দক্ষ ও অভিজ্ঞ প্রশিক্ষক। Outcome Based Education বা ফলভিত্তিক শিক্ষা পদ্ধতি এমন একটি শিক্ষার রূপরেখা যা শিক্ষার্থীদের শেখার ফলাফলকে অগ্রাধিকার দেয়। এই পদ্ধতিতে কী শিখছে, কেন শিখছে এবং শেখার পর তা ব্যবহার করতে পারছে কি না—এটাই মূল বিবেচ্য।</p>
        <p className="text-[#bfbfbf] text-xl text-justify">বাংলাদেশে OBE ধারণাটি এখনো উন্নয়নের পথে থাকলেও, ফারুক হোসেন দেশের বিভিন্ন বিশ্ববিদ্যালয়, ও শিক্ষক প্রশিক্ষণ প্রতিষ্ঠানে OBE বিষয়ক সেমিনার, কর্মশালা ও প্রশিক্ষণ পরিচালনা করে আসছেন। তিনি শিক্ষক-প্রশিক্ষণে শেখান:</p>
        <ul className="list-disc list-inside">
            <li className="text-[#bfbfbf] text-xl sm:ml-4 ml-2">
                কিভাবে কোর্স লার্নিং আউটকাম (CLO) নির্ধারণ করতে হয়
            </li>
            <li className="text-[#bfbfbf] text-xl sm:ml-4 ml-2">
                প্রোগ্রাম লার্নিং আউটকাম (PLO) এবং গ্র্যাজুয়েট অ্যাট্রিবিউট (GA) তৈরি
            </li>
            <li className="text-[#bfbfbf] text-xl sm:ml-4 ml-2">
                কিভাবে শিক্ষার্থীদের শেখার অগ্রগতি মাপা যায়
            </li>
            <li className="text-[#bfbfbf] text-xl sm:ml-4 ml-2">
                রুব্রিকস, ম্যাট্রিক্স ও ডেটা বিশ্লেষণের কৌশল
            </li>
        </ul>
        <p className="text-[#bfbfbf] text-xl text-justify">OBE বাস্তবায়নে তার অন্যতম লক্ষ্য হলো শিক্ষার মান ও দক্ষতা বৃদ্ধির মাধ্যমে আন্তর্জাতিক পর্যায়ে বাংলাদেশের শিক্ষাকে প্রতিযোগিতামূলক করে তোলা। তিনি বিশ্বাস করেন, সঠিকভাবে বাস্তবায়িত OBE পদ্ধতি শিক্ষার্থীদেরকে শুধু চাকরি পাওয়ার জন্য নয়, উদ্যোক্তা ও ভবিষ্যতের নেতৃত্বদাতা হিসেবে গড়ে তুলবে।</p>


         <span className="text-xl font-bold text-[#bfbfbf] mt-[2rem] flex items-center gap-1"><MdLabelImportant className="text-[#22BEFF]"/>জীবন পরামর্শদাতা (Life Coach) হিসেবে অবদান</span>
        <p className="text-[#bfbfbf] text-xl text-justify">শুধু শিক্ষা নয়, ফারুক হোসেন ব্যক্তি জীবনের নানা সংকটে থাকা মানুষের জন্যও পথপ্রদর্শক। তিনি একজন প্রশিক্ষিত ও পেশাদার লাইফ কোচ হিসেবে কয়েক বছর ধরে মানুষকে আত্মউন্নয়ন, ক্যারিয়ার পরিকল্পনা, মানসিক স্বাস্থ্য সচেতনতা এবং সম্পর্ক ব্যবস্থাপনায় সহায়তা করে আসছেন।</p>
        <p className="text-[#bfbfbf] text-xl text-justify">তাঁর কোচিং সেশনে বিশেষ গুরুত্ব পায়:</p>
        <ul className="list-disc list-inside">
            <li className="text-[#bfbfbf] text-xl sm:ml-4 ml-2">
                আত্মবিশ্বাস গড়ে তোলা
            </li>
            <li className="text-[#bfbfbf] text-xl sm:ml-4 ml-2">
                লক্ষ্য নির্ধারণ ও তা অর্জনের কৌশল
            </li>
            <li className="text-[#bfbfbf] text-xl sm:ml-4 ml-2">
                সময় ব্যবস্থাপনা
            </li>
            <li className="text-[#bfbfbf] text-xl sm:ml-4 ml-2">
                চাপ মোকাবেলা ও মানসিক দৃঢ়তা
            </li>
            <li className="text-[#bfbfbf] text-xl sm:ml-4 ml-2">
                পেশাগত দক্ষতা ও নেতৃত্ব গুণ
            </li>
        </ul>

         <span className="text-xl font-bold text-[#bfbfbf] mt-[2rem] flex items-center gap-1"><MdLabelImportant className="text-[#22BEFF]"/>প্রশিক্ষণ ও সেমিনার</span>
        <p className="text-[#bfbfbf] text-xl text-justify">ফারুক হোসেন নিয়মিতভাবে দেশব্যাপী বিভিন্ন প্রশিক্ষণ কর্মশালা, সেমিনার ও ওয়েবিনারে অংশ নেন এবং পরিচালনা করেন। তার প্রশিক্ষণগুলো মূলত নিম্নলিখিত শ্রেণির জন্য উপযোগী:</p>
        
        <ul className="list-disc list-inside">
            <li className="text-[#bfbfbf] text-xl sm:ml-4 ml-2">
                স্কুলের শিক্ষক ও প্রশাসক
            </li>
            <li className="text-[#bfbfbf] text-xl sm:ml-4 ml-2">
                বিশ্ববিদ্যালয় শিক্ষক ও প্রশাসক
            </li>
            <li className="text-[#bfbfbf] text-xl sm:ml-4 ml-2">
                কর্পোরেট কর্মী ও উদ্যোক্তা
            </li>
            
        </ul>

        <p className="text-[#bfbfbf] text-xl text-justify">তিনি প্রায়ই বলেন, “শেখার কোনো শেষ নেই। আমরা প্রতিদিন নতুন কিছু শিখি, যদি শেখার মানসিকতা থাকে।”</p>
        <p className="text-[#bfbfbf] text-xl text-justify">তার জীবন ও কাজ প্রমাণ করে, সত্যিকার অর্থে যিনি ‘শিক্ষক’, তিনি কেবল পাঠ দেন না—তিনি গড়ে তোলেন মানুষ, নেতৃত্ব, ও ভবিষ্যৎ।</p>


        <div className="my-[3rem] grid sm:grid-cols-2 grid-cols-1 gap-4">
            <img src={about2} alt="" className="rounded-md sm:h-[30rem]"/>
            <img src={about1} alt="" className="rounded-md sm:h-[30rem]"/>
            {/* <img src="https://www.ewubd.edu/storage/app/uploads/public/5d7/104/e0b/5d7104e0b3e77944795668.jpg" alt="" className="rounded-md"/>
            <img src="https://deh.ulab.edu.bd/sites/default/files/9th-Inter-University-Student-Conference.jpg" alt="" className="rounded-md"/>
            <img src="https://uttarauniversity.edu.bd/wp-content/uploads/2023/12/EEE-Day3-scaled.jpg" alt="" className="rounded-md"/>
            <img src="https://cdn.daily-sun.com/public/news_images/2025/03/01/1740810796-ceada3f8bea2c4f48ab4ad3a028befbd.jpg" alt="" className="rounded-md"/>
            <img src="https://cdn.daily-sun.com/public/news_images/2025/01/25/1737807677-ceada3f8bea2c4f48ab4ad3a028befbd.jpg" alt="" className="rounded-md"/>
            <img src="https://aust.edu/storage/files/WQYHinSNyzWPILeGNegFzXySHFIBc8xlq8IK4wDR.jpeg" alt="" className="rounded-md"/> */}

        </div>
      
    </div>
  );
};

export default OurCeo;
